import { defineComponent as _defineComponent } from 'vue'
import { useGetTranslations } from '~/composables/useGetTranslations';
import { useCustomerGroup } from '~/composables/useCustomerGroup';


export default /*#__PURE__*/_defineComponent({
  __name: 'PriceView',
  props: {
  price: Object,
},
  setup(__props) {

const props = __props;

const { translate } = useGetTranslations();


const { isCustomerGroupWithoutVat } = useCustomerGroup();

return { __sfc: true,translate, props, isCustomerGroupWithoutVat }
}

})